import AclName from '../../../../acl/AclName';
import httpWrap from '../../../../procedures/http-wrap';
import action from '../../../abstract/action.js';
import form from '../../../abstract/form';
import { signStatusOptions } from '../index';

const handle = async (
  {
    $vs,
    item,
    model: {
      api: {
        storeMail,
        showCrmMail,
      },
    },
    openPrompt,
  },
) => {
  const onSuccess = async (data) => {
    await httpWrap({
      $vs,
      action: storeMail,
      success: { text: 'Wysłano umowę do kontrahenta.' },
    })(item, data);
  };

  const { mail } = await httpWrap({ $vs, action: showCrmMail })(item);

  openPrompt({
    title: 'Wysyłanie dokumentu',
    acceptText: 'Wyślij',
    columns: {
      mail: { label: 'Wyślij dokument do:', form: form() },
    },
    item: {
      mail,
    },
    onSuccess,
  });
};

export default action({
  label: 'Wyślij',
  icon: 'SendIcon',
  acl: AclName.CrmBtnAgreementFileSend,
  main: ({ item }) => [signStatusOptions.onlyClient.value, signStatusOptions.onlyMe.value].includes(item.sign_status),
  handle,
});
